export const FETCH_MASTER_DDLS = "FETCH_MASTER_DDLS";
export const EMPLOYEES_DDLS = "EMPLOYEES_DDL";
export const FETCH_REQUEST_STATUS = "FETCH_REQUEST_STATUS";
export const FETCH_DEPARTMENT_DDL = "FETCH_DEPARTMENT_DDL";
export const FETCH_MASTER_ASSET_DDL = "FETCH_MASTER_ASSET_DDL";
export const FETCH_PAYROLL_COLUMN_LIST = "FETCH_PAYROLL_COLUMN_LIST";
export const FETCH_EMPLOYEE_DEPENDENT = "FETCH_EMPLOYEE_DEPENDENT";
